export const WHATSAPP_WIGGOT_CUSTOMER_SUPPORT = '+523324690493'
